var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import { superBoxStyle } from '@vital-ui/react-utils';
import styled from 'styled-components';
export var Addon = styled.div.attrs(function (props) { return ({
    className: cn('vital__addon', props.className),
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0.46633rem 0.8rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1;\n  height: 1.93267rem;\n  color: ", ";\n  text-align: center;\n  background-color: ", ";\n  border: ", ";\n  border-radius: 4px;\n  z-index: 5;\n  position: relative;\n  box-sizing: border-box;\n  ", ";\n"], ["\n  padding: 0.46633rem 0.8rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1;\n  height: 1.93267rem;\n  color: ", ";\n  text-align: center;\n  background-color: ", ";\n  border: ", ";\n  border-radius: 4px;\n  z-index: 5;\n  position: relative;\n  box-sizing: border-box;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.labelColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.form.addon.bg;
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.form.borderColor;
}, superBoxStyle);
Addon.defaultProps = {
    theme: defaultTheme,
};
export default Addon;
var templateObject_1;
//# sourceMappingURL=Addon.js.map